import React from 'react'
import { TabList } from '@hub/tabs'
import { HubStyleObject } from '@hub/design-system-base'
import { TabItemList } from './tab-list-item'
import { UniversalHeaderTabs } from '.'

export const HeaderTabs: React.FC<{
  tabsProps: React.ComponentProps<typeof UniversalHeaderTabs>
  sx: HubStyleObject
}> = ({ tabsProps, sx }) => {
  const shouldShowNational = !tabsProps.centre

  return (
    <TabList sx={sx}>
      {shouldShowNational ? (
        <TabItemList tabName="Shop online" selectedColour="vibrantTeal" />
      ) : (
        <TabItemList
          tabName="Shop online"
          selectedColour="vibrantTeal"
          url="/"
        />
      )}
      <TabItemList
        tabName={tabsProps.centre?.title ?? 'Visit a centre'}
        selectedColour="brand"
      />
    </TabList>
  )
}
